module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2849.456d1e31.png";